import React, { Component } from 'react';

class TestList extends Component {

  render() {
    return (
      <ul>
        {this.props.testProp.map( (todo, i) => {
          return <li key={i}> <input type="button" value="☓" /> {todo.title}</li>
        })}
      </ul>
    )
  }
}

export default TestList;
